class InfiniteScrollBlog extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.container = document.getElementById(this.dataset.containerId);
    this.loader = this.querySelector('[data-infinite-scroll-loader]');
  }

  connectedCallback() {
    if (!this.dataset.nextUrl || !this.container) {
      this.remove();
      return;
    }

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  onIntersect(entries) {
    if (entries.some((entry) => entry.isIntersecting)) {
      this.loadMore();
    }
  }

  async loadMore() {
    if (this.loading || !this.dataset.nextUrl) return;

    this.loading = true;
    if (this.loader) this.loader.hidden = false;

    try {
      const response = await fetch(this.dataset.nextUrl);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newContainer = html.getElementById(this.dataset.containerId);
      if (newContainer) {
        const fragment = document.createDocumentFragment();
        Array.from(newContainer.children).forEach((child) => fragment.appendChild(child));
        this.container.appendChild(fragment);

        if (typeof window.initializeScrollAnimationTrigger === 'function') {
          window.initializeScrollAnimationTrigger(this.container);
        }
      }

      const newTrigger = html.querySelector(`infinite-scroll-blog[data-container-id="${this.dataset.containerId}"]`);
      const nextUrl = newTrigger ? newTrigger.dataset.nextUrl : '';

      if (nextUrl) {
        this.dataset.nextUrl = nextUrl;
      } else {
        this.observer.disconnect();
        this.remove();
      }
    } catch (error) {
      this.observer.disconnect();
    } finally {
      this.loading = false;
      if (this.loader) this.loader.hidden = true;
    }
  }
}

customElements.define('infinite-scroll-blog', InfiniteScrollBlog);
